import { render, staticRenderFns } from "./autoSetting.vue?vue&type=template&id=479708be&scoped=true&"
import script from "./autoSetting.vue?vue&type=script&lang=js&"
export * from "./autoSetting.vue?vue&type=script&lang=js&"
import style0 from "./autoSetting.vue?vue&type=style&index=0&id=479708be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479708be",
  null
  
)

export default component.exports